// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Style card panels with blue border */
.vt-card {
  border: 1px solid #17a2b8 !important;
}

/* Remove border from inner cards (only outer container should have border) */
.vt-card .vt-card {
  border: none !important;
}

/* Improve scroll areas to avoid content overlapping with scrollbars */
.indivisualsegmentscroll {
  overflow-y: auto;
  padding-right: 8px; /* room for scrollbar so text doesn't sit under it */
}

/* Make long values (like XML paths) wrap instead of overflowing */
.segmentsubcomponent-card .small,
.segmentsubcomponent-card .lbltextwrap,
.segmentcomponent-card .lbltextwrap,
.segmentfields-card .lbltextwrap {
  word-break: break-word;
  white-space: normal;
}

/* HL7 editor should maintain preformatted spacing while allowing scroll */
#hl7texteditor {
  overflow: auto;
}

#SubcomponentHighlight {
  background-color: #1ccf2b;
}

.headerfontsize {
  font-size: 20px;
}

::ng-deep mark {
  background: #076573;
  color: white;
  display: inline;
}

::ng-deep #sampleHiglights {
  background-color: cyan;
}

.handledHighlight {
  background-color: #d80210;
}

.card {
  background-color: white;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.5em;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.badge-warning {
  background-color: #f0ad4e;
  color: #fff;
}

.badge-primary {
  background-color: #0275d8;
  color: #fff;
}

.badge-success {
  background-color: #5cb85c;
  color: #fff;
}

.badge-danger {
  background-color: #d9534f;
  color: #fff;
}

.badge-info {
  background-color: #5bc0de;
  color: #fff;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-header .badge {
  vertical-align: middle;
}
.modal-header .close {
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  cursor: pointer;
  padding: 0;
  margin: 0;
}
.modal-header .close:hover {
  opacity: 0.75;
}
.modal-header .close.text-white {
  color: #fff !important;
  opacity: 1;
}
.modal-header .close.text-white:hover {
  opacity: 0.8;
}

.function-config-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.function-config-modal .modal-header .modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}
.function-config-modal .modal-header .close.text-white {
  color: #fff !important;
  opacity: 1;
}
.function-config-modal .modal-header .close.text-white:hover {
  opacity: 0.8;
}

.function-config-modal .modal-dialog {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
}
.function-config-modal .modal-dialog .modal-header {
  flex-shrink: 0;
  background: #17a2b8;
  color: white;
  padding: 12px 16px;
  border-bottom: none;
}
.function-config-modal .modal-dialog .modal-header .modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}
.function-config-modal .modal-dialog .modal-header .close {
  color: white;
  opacity: 1;
  font-size: 1.5rem;
}
.function-config-modal .modal-dialog .modal-header .close:hover {
  opacity: 0.8;
}
.function-config-modal .modal-dialog .modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}
.function-config-modal .modal-dialog .modal-footer {
  flex-shrink: 0;
  background: #f8f9fa;
  padding: 12px 16px;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.function-config-modal .functions-list .card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  transition: box-shadow 0.2s ease;
}
.function-config-modal .functions-list .card:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.function-config-modal .functions-list .badge-info {
  background-color: #5bc0de;
  color: #fff;
  font-size: 0.75em;
  padding: 0.25em 0.5em;
}
.function-config-modal .btn-outline-primary {
  border-color: #0275d8;
  color: #0275d8;
  background-color: transparent;
}
.function-config-modal .btn-outline-primary:hover:not([disabled]) {
  background-color: #0275d8;
  color: #fff;
  border-color: #0275d8;
}

.function-config-modal,
.function-config-modal * {
  pointer-events: auto;
}

.function-config-modal .modal-dialog {
  pointer-events: auto;
}

.d-flex {
  display: flex !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.ml-2 {
  margin-left: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-center {
  text-align: center !important;
}

.text-secondary {
  color: #6c757d !important;
}

.text-info {
  color: #17a2b8 !important;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row .form-group {
  padding-right: 5px;
  padding-left: 5px;
}
.form-row .col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.btnspace {
  margin-left: 5px;
}

.lbltextwrap {
  white-space: pre-wrap;
}

.indivisualsegmentscroll {
  overflow: auto;
  background-color: white !important;
}

.indivisualsegmentnodatascroll {
  overflow: auto;
  height: 20px;
}

div.plus:before {
  content: "+";
  padding-right: 5px;
}

#truncate-text {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
}

div.minus:before {
  content: "-";
  padding-right: 5px;
}

.segment-item {
  white-space: nowrap; /* Prevent content from wrapping */
  text-overflow: ellipsis;
}

.parse-unit {
  overflow: scroll;
  white-space: nowrap;
  padding: 30px;
  margin-bottom: 30px;
  font-size: medium;
  font-weight: 200;
  line-height: 10px;
  color: inherit;
  background-color: #eeeeed;
  border-radius: 6px;
}

#container {
  overflow-x: scroll;
  white-space: nowrap;
}

#modal-content {
  overflow-x: scroll;
  white-space: nowrap;
}

.child {
  display: inline-block;
  overflow-x: hidden;
  overflow-y: auto;
  height: 51%;
}

.modal-body {
  height: 82vh;
  overflow-x: hidden;
  overflow-y: hidden;
  padding-right: 15px;
}

.modal-content {
  padding-right: 15px;
  padding-left: 15px;
  overflow-x: hidden;
  box-sizing: border-box;
}
.modal-content .modal-header {
  margin-left: -15px;
  margin-right: -15px;
  padding-left: 15px;
  padding-right: 15px;
}
.modal-content .modal-body {
  margin-left: -15px;
  margin-right: -15px;
  padding-left: 15px;
  padding-right: 15px;
  overflow-x: hidden;
  box-sizing: border-box;
}
.modal-content .modal-footer {
  margin-left: -15px;
  margin-right: -15px;
  padding-left: 15px;
  padding-right: 15px;
  box-sizing: border-box;
}

.modal-footer {
  display: block;
  padding-right: 15px;
}

#seg {
  border: 1px solid #2196f3;
}

#subc {
  border: 1px solid #2196f3;
}

.segmentfields-card {
  display: inline-block;
  width: 100%;
  overflow: auto;
}

.segmentcomponent-card {
  display: inline-block;
  width: 100%;
  overflow: auto;
}

.segmentsubcomponent-card {
  display: inline-block;
  width: 100%;
  overflow: auto;
}

.seletedsegmentfield {
  background-color: #17a0b4;
  color: #fff;
}

#hl7texteditor {
  height: 46% !important;
  border: 1px solid #2196f3;
  border-radius: 7px;
}

.note {
  color: #e90b0b;
  margin-left: 24px;
}

.sampleHiglight {
  background-color: #e90b0b !important;
}

*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.white-text {
  color: white;
}

.HL7segmentHighlight {
  background-color: #17a0b4 !important; /* You can adjust the background color as needed */
}

*::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
  border-radius: 5px;
}

div::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  border-radius: 5px;
}

body::-webkit-scrollbar-thumb {
  background-color: darkgrey;
}

.displayName_ellipsis {
  max-width: 90%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.breadcrumb .breadcrumbsucess {
  list-style: none;
  overflow: hidden;
  font: 18px Helvetica, Arial, Sans-Serif;
  margin-left: 0;
  padding: 0;
  flex-wrap: unset;
  overflow-x: auto;
  background-color: transparent;
  max-width: inherit;
}

.breadcrumb .breadcrumbsucess li {
  float: left;
}

.breadcrumb .breadcrumbsucess li a {
  color: white;
  text-decoration: none;
  padding: 5px 0 5px 55px;
  /* fallback color */
  background: hsl(180, 85%, 35%);
  position: relative;
  display: block;
  float: left;
  font-size: 12px;
}

.breadcrumb .breadcrumbsucess li a:after {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-left: 12px solid #0da5a5;
  position: absolute;
  top: 50%;
  z-index: 2;
  margin-top: -12px;
  margin-left: 0px;
  left: 100%;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
}

.breadcrumb .breadcrumbsucess li a:before {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  top: 50%;
  margin-top: -12px;
  margin-left: 2px;
  left: 100%;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 12px solid white;
  z-index: 1;
}

.breadcrumb .breadcrumbsucess li a:hover {
  background: hsl(180, 85%, 35%);
}

.breadcrumb .breadcrumbsucess li a:hover:after {
  border-left-color: hsl(180, 85%, 35%) !important;
}

.breadcrumb .breadcrumberror {
  list-style: none;
  overflow: hidden;
  font: 18px Helvetica, Arial, Sans-Serif;
  margin-left: 0;
  padding: 0;
  flex-wrap: unset;
  overflow-x: auto;
  background-color: transparent;
  max-width: inherit;
}

.breadcrumb .breadcrumberror li {
  float: left;
}

.breadcrumb .breadcrumberror li a {
  color: white;
  text-decoration: none;
  padding: 5px 0 5px 55px;
  background: rgb(233, 11, 11);
  position: relative;
  display: block;
  float: left;
  font-size: 12px;
}

.breadcrumb .breadcrumberror li a:after {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-left: 12px solid #e90b0b;
  position: absolute;
  top: 50%;
  z-index: 2;
  margin-top: -12px;
  margin-left: 0px;
  left: 100%;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
}

.breadcrumb .breadcrumberror li a:before {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  top: 50%;
  margin-top: -12px;
  margin-left: 2px;
  left: 100%;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 12px solid white;
  z-index: 1;
}

.breadcrumb .breadcrumberror li a:hover {
  background: rgb(233, 11, 11);
}

.breadcrumb .breadcrumberror li a:hover:after {
  border-left-color: rgb(233, 11, 11) !important;
}

.formcontrol {
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  line-height: 1.5;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solidrgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  border-color: rgba(120, 130, 140, 0.2);
  border-radius: 0;
}

.segmentcard {
  position: relative;
  display: flex;
  flex-direction: initial;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.list_card:hover {
  background-color: #cee4e8;
  cursor: pointer;
}

::-moz-scrollbar {
  background-color: #f1f1f1; /* Set the background color */
}

.highlighted-row {
  background-color: #d80210; /* Example background color */
  color: #fff; /* Example text color */
}

.iconpointer {
  cursor: pointer;
}

.highlighttext {
  color: red;
}

.highlighttext:hover {
  color: red !important;
}

::ng-deep.unmapped-field {
  background-color: #ffcccc !important;
  padding: 1px 2px !important;
  border-radius: 2px !important;
}

::ng-deep.mapped-field {
  cursor: help;
  padding: 1px 2px;
  border-radius: 2px;
}

.red-text {
  color: #e90b0b !important;
}

span title {
  font-size: 50px !important;
}

.modal-backdrop-custom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 20px;
}

.modal-dialog-custom {
  max-width: 60%;
  width: 60%;
  margin: auto;
  position: relative;
  z-index: 1051;
}

.modal-content-custom {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}
.modal-content-custom .modal-header {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}
.modal-content-custom .modal-header .modal-title {
  margin: 0;
  font-size: 1.25rem;
}
.modal-content-custom .modal-header .close {
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  cursor: pointer;
  padding: 0;
  margin: 0;
}
.modal-content-custom .modal-header .close:hover {
  opacity: 0.75;
}
.modal-content-custom .modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex: 1;
  max-height: calc(90vh - 120px);
}
.modal-content-custom .modal-footer {
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}
.modal-content-custom button, .modal-content-custom select, .modal-content-custom input, .modal-content-custom a {
  cursor: pointer;
}
.modal-content-custom button:disabled, .modal-content-custom select:disabled, .modal-content-custom input:disabled, .modal-content-custom a:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}`, "",{"version":3,"sources":["webpack://./src/app/hl7viewer/hl7viewer.component.scss","webpack://./../../../Git%20space/admin/standalone-hl7-viewer/src/app/hl7viewer/hl7viewer.component.scss"],"names":[],"mappings":"AAAA,uCAAA;AACA;EACE,oCAAA;ACCF;;ADEA,6EAAA;AACA;EACE,uBAAA;ACCF;;ADEA,sEAAA;AACA;EACE,gBAAA;EACA,kBAAA,EAAA,oDAAA;ACCF;;ADEA,kEAAA;AACA;;;;EAIE,sBAAA;EACA,mBAAA;ACCF;;ADEA,0EAAA;AACA;EACE,cAAA;ACCF;;ADMA;EAEE,yBAAA;ACJF;;ADOA;EACE,eAAA;ACJF;;ADMA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;ACHF;;ADMA;EAEK,sBAAA;ACJL;;ADOA;EAEE,yBAAA;ACLF;;ADOA;EACE,uBAAA;ACJF;;ADQA;EACE,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;ACLF;;ADQA;EACE,yBAAA;EACA,WAAA;ACLF;;ADQA;EACE,yBAAA;EACA,WAAA;ACLF;;ADQA;EACE,yBAAA;EACA,WAAA;ACLF;;ADQA;EACE,yBAAA;EACA,WAAA;ACLF;;ADQA;EACE,yBAAA;EACA,WAAA;ACLF;;ADSA;EACE,yBAAA;EACA,gCAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;ACNF;ADQE;EACE,sBAAA;ACNJ;ADSE;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;ACPJ;ADSI;EACE,aAAA;ACPN;ADUI;EACE,sBAAA;EACA,UAAA;ACRN;ADUM;EACE,YAAA;ACRR;;ADgBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACbJ;ADeI;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;ACbN;ADgBI;EACE,sBAAA;EACA,UAAA;ACdN;ADgBM;EACE,YAAA;ACdR;;ADsBE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;ACnBJ;ADqBI;EACE,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ACnBN;ADqBM;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;ACnBR;ADsBM;EACE,YAAA;EACA,UAAA;EACA,iBAAA;ACpBR;ADsBQ;EACE,YAAA;ACpBV;ADyBI;EACE,OAAA;EACA,gBAAA;EACA,aAAA;ACvBN;AD0BI;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;ACxBN;AD6BI;EACE,yBAAA;EACA,kBAAA;EACA,gCAAA;AC3BN;AD6BM;EACE,wCAAA;AC3BR;AD+BI;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;AC7BN;ADiCE;EACE,qBAAA;EACA,cAAA;EACA,6BAAA;AC/BJ;ADiCI;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AC/BN;;ADqCA;;EAEE,oBAAA;AClCF;;ADqCA;EACE,oBAAA;AClCF;;ADsCA;EACE,wBAAA;ACnCF;;ADsCA;EACE,yCAAA;ACnCF;;ADsCA;EACE,oCAAA;ACnCF;;ADsCA;EACE,kCAAA;ACnCF;;ADsCA;EACE,2BAAA;ACnCF;;ADsCA;EACE,gCAAA;ACnCF;;ADsCA;EACE,8BAAA;ACnCF;;ADsCA;EACE,+BAAA;ACnCF;;ADsCA;EACE,8BAAA;ACnCF;;ADsCA;EACE,2BAAA;ACnCF;;ADsCA;EACE,0BAAA;ACnCF;;ADsCA;EACE,4BAAA;EACA,+BAAA;ACnCF;;ADsCA;EACE,yBAAA;ACnCF;;ADsCA;EACE,6BAAA;ACnCF;;ADsCA;EACE,yBAAA;ACnCF;;ADsCA;EACE,yBAAA;ACnCF;;ADsCA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ACnCF;ADqCE;EACE,kBAAA;EACA,iBAAA;ACnCJ;ADsCE;EACE,aAAA;EACA,cAAA;ACpCJ;;ADwCA;EACE,gBAAA;ACrCF;;ADwCA;EACE,qBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,kCAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,YAAA;ACrCF;;ADwCA;EACE,YAAA;EACA,kBAAA;ACrCF;;ADuCA;EAEE,cAAA;EACE,mBAAA;EAEA,uBAAA;ACtCJ;;ADyCA;EACE,YAAA;EACA,kBAAA;ACtCF;;ADwCA;EAEE,mBAAA,EAAA,kCAAA;EAEA,uBAAA;ACvCF;;AD0CA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EAGA,kBAAA;ACvCF;;AD0CA;EACE,kBAAA;EACA,mBAAA;ACvCF;;AD0CA;EACE,kBAAA;EACA,mBAAA;ACvCF;;AD4CA;EACE,qBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,WAAA;AC1CF;;AD4CA;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;ACzCJ;;AD4CA;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;ACzCF;AD2CE;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;ACzCJ;AD4CE;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AC1CJ;AD6CE;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AC3CJ;;AD+CA;EACE,cAAA;EACA,mBAAA;AC5CF;;AD8CA;EACE,yBAAA;AC3CF;;AD6CA;EACE,yBAAA;AC1CF;;AD6CA;EACE,qBAAA;EAEA,WAAA;EAEA,cAAA;AC5CF;;AD+CA;EACE,qBAAA;EAEA,WAAA;EAEA,cAAA;AC9CF;;ADiDA;EACE,qBAAA;EAEA,WAAA;EAEA,cAAA;AChDF;;ADoDA;EACE,yBAAA;EACA,WAAA;ACjDF;;ADoDA;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;ACjDF;;ADqDA;EAEE,cAAA;EACA,iBAAA;ACnDF;;ADqDA;EAEE,oCAAA;ACnDF;;ADsDA;EACE,UAAA;EACA,WAAA;ACnDF;;ADqDA;EACE,YAAA;AClDF;;ADoDA;EACE,oCAAA,EAAA,kDAAA;ACjDF;;ADmDA;EACE,0BAAA;EACA,4BAAA;EACA,kBAAA;AChDF;;ADmDA;EACE,0BAAA;EACA,kBAAA;AChDF;;ADqDA;EACE,0BAAA;AClDF;;ADsDA;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ACnDF;;ADsDA;EACE,gBAAA;EACA,gBAAA;EACA,uCACE;EAGF,cAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;ACtDF;;ADyDA;EACE,WAAA;ACtDF;;ADyDA;EACE,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;ACtDF;;ADyDA;EACE,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,kCAAA;EACA,qCAAA;ACtDF;;ADyDA;EACE,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,kCAAA;EACA,qCAAA;EACA,6BAAA;EACA,UAAA;ACtDF;;ADyDA;EACE,8BAAA;ACtDF;;ADyDA;EACE,gDAAA;ACtDF;;AD0DA;EACE,gBAAA;EACA,gBAAA;EACA,uCACE;EAGF,cAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,WAAA;AC1DF;;AD6DA;EACE,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,4BAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AC1DF;;AD6DA;EACE,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,kCAAA;EACA,qCAAA;AC1DF;;AD6DA;EACE,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,kCAAA;EACA,qCAAA;EACA,6BAAA;EACA,UAAA;AC1DF;;AD6DA;EACE,4BAAA;AC1DF;;AD6DA;EACE,8CAAA;AC1DF;;AD8DA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EAEA,4BAAA;EACA,oCAAA;EACA,sBAAA;EACA,wEACE;EAEF,sCAAA;EACA,gBAAA;AC7DF;;ADgEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,sCAAA;EACA,sBAAA;AC7DF;;ADgEA;EACE,yBAAA;EACA,eAAA;AC7DF;;AD+DA;EACE,yBAAA,EAAA,6BAAA;AC5DF;;ADwEA;EACE,yBAAA,EAAA,6BAAA;EACA,WAAA,EAAA,uBAAA;ACrEF;;ADwFA;EACE,eAAA;ACrFF;;AD+FA;EACE,UAAA;AC5FF;;AD+FA;EACE,qBAAA;AC5FF;;AD+FA;EACE,oCAAA;EACA,2BAAA;EACA,6BAAA;AC5FF;;AD+FA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AC5FF;;AD+FA;EAEE,yBAAA;AC7FF;;ADgGA;EACE,0BAAA;AC7FF;;ADiGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;AC9FF;;ADiGA;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AC9FF;;ADiGA;EACE,sBAAA;EACA,kBAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AC9FF;ADgGE;EACE,aAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AC9FJ;ADgGI;EACE,SAAA;EACA,kBAAA;AC9FN;ADiGI;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AC/FN;ADiGM;EACE,aAAA;AC/FR;ADoGE;EACE,aAAA;EACA,gBAAA;EACA,OAAA;EACA,8BAAA;AClGJ;ADqGE;EACE,aAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;ACnGJ;ADuGE;EACE,eAAA;ACrGJ;ADuGI;EACE,mBAAA;EACA,aAAA;ACrGN","sourcesContent":["/* Style card panels with blue border */\n.vt-card {\n  border: 1px solid #17a2b8 !important;\n}\n\n/* Remove border from inner cards (only outer container should have border) */\n.vt-card .vt-card {\n  border: none !important;\n}\n\n/* Improve scroll areas to avoid content overlapping with scrollbars */\n.indivisualsegmentscroll {\n  overflow-y: auto;\n  padding-right: 8px; /* room for scrollbar so text doesn't sit under it */\n}\n\n/* Make long values (like XML paths) wrap instead of overflowing */\n.segmentsubcomponent-card .small,\n.segmentsubcomponent-card .lbltextwrap,\n.segmentcomponent-card .lbltextwrap,\n.segmentfields-card .lbltextwrap {\n  word-break: break-word;\n  white-space: normal;\n}\n\n/* HL7 editor should maintain preformatted spacing while allowing scroll */\n#hl7texteditor {\n  overflow: auto;\n}\n\n// .mainheader {\n//   background-color: #3697dc;\n//   color: white;\n// }\n#SubcomponentHighlight\n{\n  background-color: #1ccf2b;\n}\n\n.headerfontsize {\n  font-size: 20px;\n}\n::ng-deep mark {\n  background: #076573;\n  color: white;\n  display: inline;\n}\n\n::ng-deep #sampleHiglights\n{\n     background-color: cyan;\n}\n\n.handledHighlight\n{\n  background-color: #d80210;\n}\n.card {\n  background-color: white;\n}\n\n// Badge styles matching original UI\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.5em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n}\n\n.badge-warning {\n  background-color: #f0ad4e;\n  color: #fff;\n}\n\n.badge-primary {\n  background-color: #0275d8;\n  color: #fff;\n}\n\n.badge-success {\n  background-color: #5cb85c;\n  color: #fff;\n}\n\n.badge-danger {\n  background-color: #d9534f;\n  color: #fff;\n}\n\n.badge-info {\n  background-color: #5bc0de;\n  color: #fff;\n}\n\n// Modal header styling\n.modal-header {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n  padding: 0.5rem 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  \n  .badge {\n    vertical-align: middle;\n  }\n  \n  .close {\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 1;\n    color: #000;\n    opacity: 0.5;\n    cursor: pointer;\n    padding: 0;\n    margin: 0;\n    \n    &:hover {\n      opacity: 0.75;\n    }\n    \n    &.text-white {\n      color: #fff !important;\n      opacity: 1;\n      \n      &:hover {\n        opacity: 0.8;\n      }\n    }\n  }\n}\n\n// Function Config Modal Styles\n.function-config-modal {\n  .modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    \n    .modal-title {\n      margin: 0;\n      font-size: 1.25rem;\n      font-weight: 600;\n    }\n    \n    .close.text-white {\n      color: #fff !important;\n      opacity: 1;\n      \n      &:hover {\n        opacity: 0.8;\n      }\n    }\n  }\n}\n\n// Function Config Modal Styles\n.function-config-modal {\n  .modal-dialog {\n    display: flex;\n    flex-direction: column;\n    max-height: 80vh;\n    \n    .modal-header {\n      flex-shrink: 0;\n      background: #17a2b8;\n      color: white;\n      padding: 12px 16px;\n      border-bottom: none;\n      \n      .modal-title {\n        margin: 0;\n        font-size: 1.25rem;\n        font-weight: 600;\n      }\n      \n      .close {\n        color: white;\n        opacity: 1;\n        font-size: 1.5rem;\n        \n        &:hover {\n          opacity: 0.8;\n        }\n      }\n    }\n    \n    .modal-body {\n      flex: 1;\n      overflow-y: auto;\n      padding: 16px;\n    }\n    \n    .modal-footer {\n      flex-shrink: 0;\n      background: #f8f9fa;\n      padding: 12px 16px;\n      border-top: 1px solid #dee2e6;\n      display: flex;\n      justify-content: flex-end;\n      gap: 8px;\n    }\n  }\n  \n  .functions-list {\n    .card {\n      border: 1px solid #dee2e6;\n      border-radius: 4px;\n      transition: box-shadow 0.2s ease;\n      \n      &:hover {\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      }\n    }\n    \n    .badge-info {\n      background-color: #5bc0de;\n      color: #fff;\n      font-size: 0.75em;\n      padding: 0.25em 0.5em;\n    }\n  }\n  \n  .btn-outline-primary {\n    border-color: #0275d8;\n    color: #0275d8;\n    background-color: transparent;\n    \n    &:hover:not([disabled]) {\n      background-color: #0275d8;\n      color: #fff;\n      border-color: #0275d8;\n    }\n  }\n}\n\n// Ensure buttons are clickable\n.function-config-modal,\n.function-config-modal * {\n  pointer-events: auto;\n}\n\n.function-config-modal .modal-dialog {\n  pointer-events: auto;\n}\n\n// Bootstrap utility classes (if not available)\n.d-flex {\n  display: flex !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mr-2 {\n  margin-right: 0.5rem !important;\n}\n\n.ml-2 {\n  margin-left: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.py-4 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.text-muted {\n  color: #6c757d !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-secondary {\n  color: #6c757d !important;\n}\n\n.text-info {\n  color: #17a2b8 !important;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n  \n  .form-group {\n    padding-right: 5px;\n    padding-left: 5px;\n  }\n  \n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n\n.btnspace {\n  margin-left: 5px;\n}\n\n.lbltextwrap {\n  white-space: pre-wrap;\n}\n\n.indivisualsegmentscroll {\n  overflow: auto;\n  background-color: white !important;\n}\n\n.indivisualsegmentnodatascroll {\n  overflow: auto;\n  height: 20px;\n}\n\ndiv.plus:before {\n  content: \"+\";\n  padding-right: 5px;\n}\n#truncate-text\n{\n  display: block;\n    white-space: nowrap;\n\n    text-overflow: ellipsis;\n}\n\ndiv.minus:before {\n  content: \"-\";\n  padding-right: 5px;\n}\n.segment-item\n{\n  white-space: nowrap; /* Prevent content from wrapping */\n\n  text-overflow: ellipsis;\n\n}\n.parse-unit {\n  overflow: scroll;\n  white-space: nowrap;\n  padding: 30px;\n  margin-bottom: 30px;\n  font-size: medium;\n  font-weight: 200;\n  line-height: 10px;\n  color: inherit;\n  background-color: #eeeeed;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n\n#container {\n  overflow-x: scroll;\n  white-space: nowrap;\n}\n\n#modal-content {\n  overflow-x: scroll;\n  white-space: nowrap;\n}\n\n\n\n.child {\n  display: inline-block;\n\n  overflow-x: hidden;\n  overflow-y: auto;\n  height: 51%;\n}\n.modal-body{\n    height: 82vh;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    padding-right: 15px;\n}\n\n.modal-content {\n  padding-right: 15px;\n  padding-left: 15px;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  \n  .modal-header {\n    margin-left: -15px;\n    margin-right: -15px;\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  \n  .modal-body {\n    margin-left: -15px;\n    margin-right: -15px;\n    padding-left: 15px;\n    padding-right: 15px;\n    overflow-x: hidden;\n    box-sizing: border-box;\n  }\n  \n  .modal-footer {\n    margin-left: -15px;\n    margin-right: -15px;\n    padding-left: 15px;\n    padding-right: 15px;\n    box-sizing: border-box;\n  }\n}\n\n.modal-footer{\n  display: block;\n  padding-right: 15px;\n}\n#seg{\n  border: 1px solid #2196f3\n}\n#subc{\n  border: 1px solid #2196f3\n}\n\n.segmentfields-card {\n  display: inline-block;\n  // width: 670px;\n  width: 100%;\n\n  overflow: auto;\n}\n\n.segmentcomponent-card {\n  display: inline-block;\n  // width: 670px;\n  width: 100%;\n\n  overflow: auto;\n}\n\n.segmentsubcomponent-card {\n  display: inline-block;\n  // width: 670px;\n  width: 100%;\n\n  overflow: auto;\n\n}\n\n.seletedsegmentfield {\n  background-color: #17a0b4 ;\n  color: #fff;\n}\n\n#hl7texteditor {\n  height: 46% !important;\n  border: 1px solid #2196f3;;\n  border-radius: 7px;\n\n}\n\n.note\n{\n  color: #e90b0b;\n  margin-left: 24px;\n}\n.sampleHiglight\n{\n  background-color: #e90b0b !important;\n}\n\n*::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n.white-text {\n  color: white;\n}\n.HL7segmentHighlight {\n  background-color: #17a0b4 !important; /* You can adjust the background color as needed */\n}\n*::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  outline: 1px solid slategrey;\n  border-radius: 5px;\n}\n\ndiv::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  border-radius: 5px;\n\n\n}\n\nbody::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n\n}\n\n.displayName_ellipsis {\n  max-width: 90%;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.breadcrumb .breadcrumbsucess {\n  list-style: none;\n  overflow: hidden;\n  font:\n    18px Helvetica,\n    Arial,\n    Sans-Serif;\n  margin-left: 0;\n  padding: 0;\n  flex-wrap: unset;\n  overflow-x: auto;\n  background-color: transparent;\n  max-width: inherit;\n}\n\n.breadcrumb .breadcrumbsucess li {\n  float: left;\n}\n\n.breadcrumb .breadcrumbsucess li a {\n  color: white;\n  text-decoration: none;\n  padding: 5px 0 5px 55px;\n  /* fallback color */\n  background: hsl(180deg 85% 35%);\n  position: relative;\n  display: block;\n  float: left;\n  font-size: 12px;\n}\n\n.breadcrumb .breadcrumbsucess li a:after {\n  content: \" \";\n  display: block;\n  width: 0;\n  height: 0;\n  border-left: 12px solid #0da5a5;\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  margin-top: -12px;\n  margin-left: 0px;\n  left: 100%;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n}\n\n.breadcrumb .breadcrumbsucess li a:before {\n  content: \" \";\n  display: block;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 50%;\n  margin-top: -12px;\n  margin-left: 2px;\n  left: 100%;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  border-left: 12px solid white;\n  z-index: 1;\n}\n\n.breadcrumb .breadcrumbsucess li a:hover {\n  background: hsl(180deg 85% 35%);\n}\n\n.breadcrumb .breadcrumbsucess li a:hover:after {\n  border-left-color: hsl(180deg 85% 35%) !important;\n}\n\n// failure\n.breadcrumb .breadcrumberror {\n  list-style: none;\n  overflow: hidden;\n  font:\n    18px Helvetica,\n    Arial,\n    Sans-Serif;\n  margin-left: 0;\n  padding: 0;\n  flex-wrap: unset;\n  overflow-x: auto;\n  background-color: transparent;\n  max-width: inherit;\n}\n\n.breadcrumb .breadcrumberror li {\n  float: left;\n}\n\n.breadcrumb .breadcrumberror li a {\n  color: white;\n  text-decoration: none;\n  padding: 5px 0 5px 55px;\n  background: rgb(233, 11, 11);\n  position: relative;\n  display: block;\n  float: left;\n  font-size: 12px;\n}\n\n.breadcrumb .breadcrumberror li a:after {\n  content: \" \";\n  display: block;\n  width: 0;\n  height: 0;\n  border-left: 12px solid #e90b0b;\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  margin-top: -12px;\n  margin-left: 0px;\n  left: 100%;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n}\n\n.breadcrumb .breadcrumberror li a:before {\n  content: \" \";\n  display: block;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 50%;\n  margin-top: -12px;\n  margin-left: 2px;\n  left: 100%;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  border-left: 12px solid white;\n  z-index: 1;\n}\n\n.breadcrumb .breadcrumberror li a:hover {\n  background: rgb(233, 11, 11);\n}\n\n.breadcrumb .breadcrumberror li a:hover:after {\n  border-left-color: rgb(233, 11, 11) !important;\n}\n\n\n.formcontrol {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  line-height: 1.5;\n  color: #464a4c;\n  background-color: #fff;\n  background-image: none;\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  border: 1px solidrgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n  transition:\n    border-color ease-in-out 0.15s,\n    box-shadow ease-in-out 0.15s;\n  border-color: rgba(120, 130, 140, 0.2);\n  border-radius: 0;\n}\n\n.segmentcard {\n  position: relative;\n  display: flex;\n  flex-direction: initial;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.25rem;\n}\n\n.list_card:hover {\n  background-color:  #cee4e8 ;;\n  cursor: pointer;\n}\n::-moz-scrollbar {\n  background-color: #f1f1f1; /* Set the background color */\n}\n\n// ::selection {\n//   // background-color: #ea5c80;\n//   // color: black;\n//   // background-color: #464a4cc7;\n//   // color: #fff;\n//   background-color: #0275d8;\n//   color: #fff;\n// }\n\n.highlighted-row {\n  background-color: #d80210; /* Example background color */\n  color: #fff; /* Example text color */\n}\n// ::ng-deep #highlightText {\n//   background: cyan;\n// }\n\n// mark {\n//   border-radius: 3px;\n//   color: transparent;\n//   background-color: #d01313;\n// }\n// CSS\n\n// textarea::selection {\n//   background-color: #2612d6;\n//   color: #fff;\n// }\n\n\n.iconpointer {\n  cursor: pointer;\n}\n\n// i:hover {\n//   color: orange !important;\n// }\n.TextHighlight\n{\n\n}\n.highlighttext {\n  color: red;\n}\n\n.highlighttext:hover {\n  color: red !important;\n}\n\n::ng-deep.unmapped-field {\n  background-color: #ffcccc !important; // Light red\n  padding: 1px 2px !important;\n  border-radius: 2px !important;\n}\n\n::ng-deep.mapped-field {\n  cursor: help;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n\n.red-text\n{\n  color: #e90b0b !important;\n}\n\nspan title {\n  font-size: 50px !important;\n}\n\n// Mapping modal styles - Custom implementation for sticky modal\n.modal-backdrop-custom {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.modal-dialog-custom {\n  max-width: 60%;\n  width: 60%;\n  margin: auto;\n  position: relative;\n  z-index: 1051;\n}\n\n.modal-content-custom {\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n  overflow: hidden;\n  \n  .modal-header {\n    padding: 1rem;\n    border-bottom: 1px solid #dee2e6;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-shrink: 0;\n    \n    .modal-title {\n      margin: 0;\n      font-size: 1.25rem;\n    }\n    \n    .close {\n      background: none;\n      border: none;\n      font-size: 1.5rem;\n      font-weight: 700;\n      line-height: 1;\n      color: #000;\n      opacity: 0.5;\n      cursor: pointer;\n      padding: 0;\n      margin: 0;\n      \n      &:hover {\n        opacity: 0.75;\n      }\n    }\n  }\n  \n  .modal-body {\n    padding: 1rem;\n    overflow-y: auto;\n    flex: 1;\n    max-height: calc(90vh - 120px);\n  }\n  \n  .modal-footer {\n    padding: 1rem;\n    border-top: 1px solid #dee2e6;\n    display: flex;\n    justify-content: flex-end;\n    flex-shrink: 0;\n  }\n  \n  // Ensure all interactive elements work\n  button, select, input, a {\n    cursor: pointer;\n    \n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.65;\n    }\n  }\n}","/* Style card panels with blue border */\n.vt-card {\n  border: 1px solid #17a2b8 !important;\n}\n\n/* Remove border from inner cards (only outer container should have border) */\n.vt-card .vt-card {\n  border: none !important;\n}\n\n/* Improve scroll areas to avoid content overlapping with scrollbars */\n.indivisualsegmentscroll {\n  overflow-y: auto;\n  padding-right: 8px; /* room for scrollbar so text doesn't sit under it */\n}\n\n/* Make long values (like XML paths) wrap instead of overflowing */\n.segmentsubcomponent-card .small,\n.segmentsubcomponent-card .lbltextwrap,\n.segmentcomponent-card .lbltextwrap,\n.segmentfields-card .lbltextwrap {\n  word-break: break-word;\n  white-space: normal;\n}\n\n/* HL7 editor should maintain preformatted spacing while allowing scroll */\n#hl7texteditor {\n  overflow: auto;\n}\n\n#SubcomponentHighlight {\n  background-color: #1ccf2b;\n}\n\n.headerfontsize {\n  font-size: 20px;\n}\n\n::ng-deep mark {\n  background: #076573;\n  color: white;\n  display: inline;\n}\n\n::ng-deep #sampleHiglights {\n  background-color: cyan;\n}\n\n.handledHighlight {\n  background-color: #d80210;\n}\n\n.card {\n  background-color: white;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.5em;\n  font-size: 75%;\n  font-weight: bold;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n}\n\n.badge-warning {\n  background-color: #f0ad4e;\n  color: #fff;\n}\n\n.badge-primary {\n  background-color: #0275d8;\n  color: #fff;\n}\n\n.badge-success {\n  background-color: #5cb85c;\n  color: #fff;\n}\n\n.badge-danger {\n  background-color: #d9534f;\n  color: #fff;\n}\n\n.badge-info {\n  background-color: #5bc0de;\n  color: #fff;\n}\n\n.modal-header {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n  padding: 0.5rem 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.modal-header .badge {\n  vertical-align: middle;\n}\n.modal-header .close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  opacity: 0.5;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n}\n.modal-header .close:hover {\n  opacity: 0.75;\n}\n.modal-header .close.text-white {\n  color: #fff !important;\n  opacity: 1;\n}\n.modal-header .close.text-white:hover {\n  opacity: 0.8;\n}\n\n.function-config-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.function-config-modal .modal-header .modal-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n.function-config-modal .modal-header .close.text-white {\n  color: #fff !important;\n  opacity: 1;\n}\n.function-config-modal .modal-header .close.text-white:hover {\n  opacity: 0.8;\n}\n\n.function-config-modal .modal-dialog {\n  display: flex;\n  flex-direction: column;\n  max-height: 80vh;\n}\n.function-config-modal .modal-dialog .modal-header {\n  flex-shrink: 0;\n  background: #17a2b8;\n  color: white;\n  padding: 12px 16px;\n  border-bottom: none;\n}\n.function-config-modal .modal-dialog .modal-header .modal-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n.function-config-modal .modal-dialog .modal-header .close {\n  color: white;\n  opacity: 1;\n  font-size: 1.5rem;\n}\n.function-config-modal .modal-dialog .modal-header .close:hover {\n  opacity: 0.8;\n}\n.function-config-modal .modal-dialog .modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n}\n.function-config-modal .modal-dialog .modal-footer {\n  flex-shrink: 0;\n  background: #f8f9fa;\n  padding: 12px 16px;\n  border-top: 1px solid #dee2e6;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.function-config-modal .functions-list .card {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  transition: box-shadow 0.2s ease;\n}\n.function-config-modal .functions-list .card:hover {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.function-config-modal .functions-list .badge-info {\n  background-color: #5bc0de;\n  color: #fff;\n  font-size: 0.75em;\n  padding: 0.25em 0.5em;\n}\n.function-config-modal .btn-outline-primary {\n  border-color: #0275d8;\n  color: #0275d8;\n  background-color: transparent;\n}\n.function-config-modal .btn-outline-primary:hover:not([disabled]) {\n  background-color: #0275d8;\n  color: #fff;\n  border-color: #0275d8;\n}\n\n.function-config-modal,\n.function-config-modal * {\n  pointer-events: auto;\n}\n\n.function-config-modal .modal-dialog {\n  pointer-events: auto;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mr-2 {\n  margin-right: 0.5rem !important;\n}\n\n.ml-2 {\n  margin-left: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.py-4 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.text-muted {\n  color: #6c757d !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-secondary {\n  color: #6c757d !important;\n}\n\n.text-info {\n  color: #17a2b8 !important;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n.form-row .form-group {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n.form-row .col-md-6 {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.btnspace {\n  margin-left: 5px;\n}\n\n.lbltextwrap {\n  white-space: pre-wrap;\n}\n\n.indivisualsegmentscroll {\n  overflow: auto;\n  background-color: white !important;\n}\n\n.indivisualsegmentnodatascroll {\n  overflow: auto;\n  height: 20px;\n}\n\ndiv.plus:before {\n  content: \"+\";\n  padding-right: 5px;\n}\n\n#truncate-text {\n  display: block;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\ndiv.minus:before {\n  content: \"-\";\n  padding-right: 5px;\n}\n\n.segment-item {\n  white-space: nowrap; /* Prevent content from wrapping */\n  text-overflow: ellipsis;\n}\n\n.parse-unit {\n  overflow: scroll;\n  white-space: nowrap;\n  padding: 30px;\n  margin-bottom: 30px;\n  font-size: medium;\n  font-weight: 200;\n  line-height: 10px;\n  color: inherit;\n  background-color: #eeeeed;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n\n#container {\n  overflow-x: scroll;\n  white-space: nowrap;\n}\n\n#modal-content {\n  overflow-x: scroll;\n  white-space: nowrap;\n}\n\n.child {\n  display: inline-block;\n  overflow-x: hidden;\n  overflow-y: auto;\n  height: 51%;\n}\n\n.modal-body {\n  height: 82vh;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  padding-right: 15px;\n}\n\n.modal-content {\n  padding-right: 15px;\n  padding-left: 15px;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n.modal-content .modal-header {\n  margin-left: -15px;\n  margin-right: -15px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.modal-content .modal-body {\n  margin-left: -15px;\n  margin-right: -15px;\n  padding-left: 15px;\n  padding-right: 15px;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n.modal-content .modal-footer {\n  margin-left: -15px;\n  margin-right: -15px;\n  padding-left: 15px;\n  padding-right: 15px;\n  box-sizing: border-box;\n}\n\n.modal-footer {\n  display: block;\n  padding-right: 15px;\n}\n\n#seg {\n  border: 1px solid #2196f3;\n}\n\n#subc {\n  border: 1px solid #2196f3;\n}\n\n.segmentfields-card {\n  display: inline-block;\n  width: 100%;\n  overflow: auto;\n}\n\n.segmentcomponent-card {\n  display: inline-block;\n  width: 100%;\n  overflow: auto;\n}\n\n.segmentsubcomponent-card {\n  display: inline-block;\n  width: 100%;\n  overflow: auto;\n}\n\n.seletedsegmentfield {\n  background-color: #17a0b4;\n  color: #fff;\n}\n\n#hl7texteditor {\n  height: 46% !important;\n  border: 1px solid #2196f3;\n  border-radius: 7px;\n}\n\n.note {\n  color: #e90b0b;\n  margin-left: 24px;\n}\n\n.sampleHiglight {\n  background-color: #e90b0b !important;\n}\n\n*::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.white-text {\n  color: white;\n}\n\n.HL7segmentHighlight {\n  background-color: #17a0b4 !important; /* You can adjust the background color as needed */\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  outline: 1px solid slategrey;\n  border-radius: 5px;\n}\n\ndiv::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  border-radius: 5px;\n}\n\nbody::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n}\n\n.displayName_ellipsis {\n  max-width: 90%;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.breadcrumb .breadcrumbsucess {\n  list-style: none;\n  overflow: hidden;\n  font: 18px Helvetica, Arial, Sans-Serif;\n  margin-left: 0;\n  padding: 0;\n  flex-wrap: unset;\n  overflow-x: auto;\n  background-color: transparent;\n  max-width: inherit;\n}\n\n.breadcrumb .breadcrumbsucess li {\n  float: left;\n}\n\n.breadcrumb .breadcrumbsucess li a {\n  color: white;\n  text-decoration: none;\n  padding: 5px 0 5px 55px;\n  /* fallback color */\n  background: hsl(180, 85%, 35%);\n  position: relative;\n  display: block;\n  float: left;\n  font-size: 12px;\n}\n\n.breadcrumb .breadcrumbsucess li a:after {\n  content: \" \";\n  display: block;\n  width: 0;\n  height: 0;\n  border-left: 12px solid #0da5a5;\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  margin-top: -12px;\n  margin-left: 0px;\n  left: 100%;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n}\n\n.breadcrumb .breadcrumbsucess li a:before {\n  content: \" \";\n  display: block;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 50%;\n  margin-top: -12px;\n  margin-left: 2px;\n  left: 100%;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  border-left: 12px solid white;\n  z-index: 1;\n}\n\n.breadcrumb .breadcrumbsucess li a:hover {\n  background: hsl(180, 85%, 35%);\n}\n\n.breadcrumb .breadcrumbsucess li a:hover:after {\n  border-left-color: hsl(180, 85%, 35%) !important;\n}\n\n.breadcrumb .breadcrumberror {\n  list-style: none;\n  overflow: hidden;\n  font: 18px Helvetica, Arial, Sans-Serif;\n  margin-left: 0;\n  padding: 0;\n  flex-wrap: unset;\n  overflow-x: auto;\n  background-color: transparent;\n  max-width: inherit;\n}\n\n.breadcrumb .breadcrumberror li {\n  float: left;\n}\n\n.breadcrumb .breadcrumberror li a {\n  color: white;\n  text-decoration: none;\n  padding: 5px 0 5px 55px;\n  background: rgb(233, 11, 11);\n  position: relative;\n  display: block;\n  float: left;\n  font-size: 12px;\n}\n\n.breadcrumb .breadcrumberror li a:after {\n  content: \" \";\n  display: block;\n  width: 0;\n  height: 0;\n  border-left: 12px solid #e90b0b;\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  margin-top: -12px;\n  margin-left: 0px;\n  left: 100%;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n}\n\n.breadcrumb .breadcrumberror li a:before {\n  content: \" \";\n  display: block;\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 50%;\n  margin-top: -12px;\n  margin-left: 2px;\n  left: 100%;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  border-left: 12px solid white;\n  z-index: 1;\n}\n\n.breadcrumb .breadcrumberror li a:hover {\n  background: rgb(233, 11, 11);\n}\n\n.breadcrumb .breadcrumberror li a:hover:after {\n  border-left-color: rgb(233, 11, 11) !important;\n}\n\n.formcontrol {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  line-height: 1.5;\n  color: #464a4c;\n  background-color: #fff;\n  background-image: none;\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  border: 1px solidrgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  border-color: rgba(120, 130, 140, 0.2);\n  border-radius: 0;\n}\n\n.segmentcard {\n  position: relative;\n  display: flex;\n  flex-direction: initial;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.25rem;\n}\n\n.list_card:hover {\n  background-color: #cee4e8;\n  cursor: pointer;\n}\n\n::-moz-scrollbar {\n  background-color: #f1f1f1; /* Set the background color */\n}\n\n.highlighted-row {\n  background-color: #d80210; /* Example background color */\n  color: #fff; /* Example text color */\n}\n\n.iconpointer {\n  cursor: pointer;\n}\n\n.highlighttext {\n  color: red;\n}\n\n.highlighttext:hover {\n  color: red !important;\n}\n\n::ng-deep.unmapped-field {\n  background-color: #ffcccc !important;\n  padding: 1px 2px !important;\n  border-radius: 2px !important;\n}\n\n::ng-deep.mapped-field {\n  cursor: help;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n\n.red-text {\n  color: #e90b0b !important;\n}\n\nspan title {\n  font-size: 50px !important;\n}\n\n.modal-backdrop-custom {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.modal-dialog-custom {\n  max-width: 60%;\n  width: 60%;\n  margin: auto;\n  position: relative;\n  z-index: 1051;\n}\n\n.modal-content-custom {\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n  overflow: hidden;\n}\n.modal-content-custom .modal-header {\n  padding: 1rem;\n  border-bottom: 1px solid #dee2e6;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n.modal-content-custom .modal-header .modal-title {\n  margin: 0;\n  font-size: 1.25rem;\n}\n.modal-content-custom .modal-header .close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  opacity: 0.5;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n}\n.modal-content-custom .modal-header .close:hover {\n  opacity: 0.75;\n}\n.modal-content-custom .modal-body {\n  padding: 1rem;\n  overflow-y: auto;\n  flex: 1;\n  max-height: calc(90vh - 120px);\n}\n.modal-content-custom .modal-footer {\n  padding: 1rem;\n  border-top: 1px solid #dee2e6;\n  display: flex;\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n.modal-content-custom button, .modal-content-custom select, .modal-content-custom input, .modal-content-custom a {\n  cursor: pointer;\n}\n.modal-content-custom button:disabled, .modal-content-custom select:disabled, .modal-content-custom input:disabled, .modal-content-custom a:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
